// FAZ C — Pencere düzeni hafızası.
// Mevcut geometri deposunun (localStorage) ÜZERİNE çalışır; react-rnd /
// dnd-kit çekirdeğine dokunmaz. Pencereler mount anında geometriyi
// localStorage'dan okuduğu için strateji: ÖNCE geometriyi yaz, SONRA aç.
import { api } from "./api";

const TASK_GEOM_KEY = "sertex_detached_task_geom_v1";
const PANEL_GEOM_KEY = "sertex_detached_panel_geom_v1";

// Okunabilirlik alt sınırı — pencereler bunun altına düşmez.
const MIN_W = 300;
const MIN_H = 200;
const KENAR = 8;

const clamp = (v, lo, hi) => Math.max(lo, Math.min(hi, v));

const readJson = (key) => {
  try {
    return JSON.parse(localStorage.getItem(key) || "{}") || {};
  } catch {
    return {};
  }
};

const writeJson = (key, val) => {
  try {
    localStorage.setItem(key, JSON.stringify(val));
  } catch (e) {
    console.warn("[windowLayouts] yazma başarısız:", e);
  }
};

export const currentViewport = () => ({ w: window.innerWidth, h: window.innerHeight });

// Görev: <taskId> · Alt görev: sub:<subId> · Kategori: panel id (dp_...)
export const taskGeomKeyOf = (kind, itemId) =>
  kind === "subtask" ? `sub:${itemId}` : itemId;

export const readTaskGeom = (kind, itemId) => readJson(TASK_GEOM_KEY)[taskGeomKeyOf(kind, itemId)] || null;
export const readPanelGeom = (panelId) => readJson(PANEL_GEOM_KEY)[panelId] || null;

export const writeTaskGeom = (kind, itemId, geom) => {
  const all = readJson(TASK_GEOM_KEY);
  all[taskGeomKeyOf(kind, itemId)] = geom;
  writeJson(TASK_GEOM_KEY, all);
};

export const writePanelGeom = (panelId, geom) => {
  const all = readJson(PANEL_GEOM_KEY);
  all[panelId] = geom;
  writeJson(PANEL_GEOM_KEY, all);
};

// KABUL 5 — Kaydedilen ekrana göre ORANSAL uyarla, sonra mevcut ekrana SIKIŞTIR.
// Büyük ekranda kaydedip küçük ekranda açınca taşma olmaz; tersinde pencereler
// sol üst köşeye yığılmaz, oransal olarak yayılır.
export const fitGeom = (g, savedVp, vp = currentViewport()) => {
  const sx = savedVp?.w > 0 ? vp.w / savedVp.w : 1;
  const sy = savedVp?.h > 0 ? vp.h / savedVp.h : 1;
  const width = clamp(Math.round((g.width || MIN_W) * sx), MIN_W, Math.max(MIN_W, vp.w - KENAR * 2));
  const height = clamp(Math.round((g.height || MIN_H) * sy), MIN_H, Math.max(MIN_H, vp.h - KENAR * 2));
  const x = clamp(Math.round((g.x || 0) * sx), KENAR, Math.max(KENAR, vp.w - width - KENAR));
  const y = clamp(Math.round((g.y || 0) * sy), KENAR, Math.max(KENAR, vp.h - height - KENAR));
  return { x, y, width, height };
};

// --- API ---
export const layoutsApi = {
  list: () => api.get("/window-layouts").then((r) => r.data),
  create: (payload) => api.post("/window-layouts", payload).then((r) => r.data),
  update: (id, payload) => api.put(`/window-layouts/${id}`, payload).then((r) => r.data),
  remove: (id) => api.delete(`/window-layouts/${id}`).then((r) => r.data),
  getPrefs: () => api.get("/window-layouts/prefs").then((r) => r.data),
  setPrefs: (payload) => api.put("/window-layouts/prefs", payload).then((r) => r.data),
};
